import { getUseBaseFetch, RequestMethodsEnum, UseBaseFetchProps } from '@systemeio/util';
import { toast } from 'shared/components';
import { useRouter } from 'shared/hooks/use-router';
import { httpClient } from 'shared/utils/http-client';
const useBaseFetch = getUseBaseFetch({
  httpClient,
  useRouter,
  toast
});
export const useFetch = props => {
  return useBaseFetch(props);
};